import { GridColumns } from '@mui/x-data-grid-pro'
import { ProductOrderDto } from '@services/dtos'
import { useEffect } from 'react'
import { useAppDispatch } from '@hooks/reduxHooks'
import { getScheduledDeliveries, resetScheduledDeliveries, setScheduledDeliveriesFilters } from '@state/reducers/productOrderReducer'
import { AppDispatch, useSelector } from '@state/store'
import { productOrdersColumns } from '@utils/gridColumns'
import BaseConfigTable from './BaseConfigTable'

export default function ProductScheduledDeliveriesTable() {
  const dispatch = useAppDispatch()
  useEffect(() => {
    dispatch(getScheduledDeliveries())
    return () => {
      dispatch(resetScheduledDeliveries())
    }
  }, [])

  const { filters } = useSelector(({ productOrder }) => ({ filters: productOrder.scheduledDeliveries.filters }))
  useEffect(() => {
    dispatch(getScheduledDeliveries())
  }, [filters, dispatch])

  const columns: GridColumns<ProductOrderDto> = [
    ...productOrdersColumns.filter(column => ['internalOrderNumber', 'supplier', 'site', 'shipping'].includes(column.field)),
    { 
      field: 'expectedProducts', 
      headerName: 'Produits attendus', 
      width: 400,
      valueGetter: (params) =>
        params.row.lineItems
          .map(({ remainingQuantity, product }) => `${remainingQuantity} ${product.name}`)
          .join(', ')
    },
  ]
  
  return (
    <BaseConfigTable<ProductOrderDto>
      columns={columns}
      selectRows={(state) => state.productOrder.scheduledDeliveries.items}
      fetchThunk={() => async (dispatch: AppDispatch) => {
        return dispatch(getScheduledDeliveries())
      }}
      withActions={false}
      updatePageThunk={(page) => async (dispatch: AppDispatch) => {
        dispatch(setScheduledDeliveriesFilters({ page }))
        dispatch(getScheduledDeliveries())
      }}
      removeToolbar
    />
  )
}
